import { cva } from '@/styled-system/css';

export const menuItemLabelRecipe = cva({
  base: {
    display: 'block',
    gridArea: 'label',
    textStyle: 'body',
  },
  variants: {
    anchor: {
      true: {
        color: { base: 'text.action.neutral.default' },
      },
      false: {
        color: { base: 'text.action.neutral.default' },
      },
    },
    disabled: {
      true: {},
      false: {},
    },
  },
  compoundVariants: [
    {
      anchor: true,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.link.hover',
          _groupActive: 'text.action.neutral.pressed',
        },
      },
    },
    {
      anchor: false,
      disabled: false,
      css: {
        color: {
          _groupHover: 'text.action.neutral.hover',
          _groupActive: 'text.action.neutral.pressed',
        },
      },
    },
  ],
});
